var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7734 12L14.3949 13.6215C14.6085 13.8351 14.6086 14.1813 14.395 14.3949C14.1814 14.6085 13.8351 14.6085 13.6216 14.3949L12 12.7734L10.3784 14.3949C10.1649 14.6085 9.81869 14.6085 9.60505 14.3949C9.39147 14.1814 9.3915 13.8351 9.60508 13.6215L11.2266 12L9.60508 10.3785C9.3915 10.1649 9.3915 9.81865 9.60505 9.60507C9.81861 9.39149 10.1649 9.39149 10.3784 9.60507L12 11.2266L13.6216 9.60507C13.8351 9.39151 14.1814 9.39149 14.395 9.60507C14.6085 9.81865 14.6085 10.1649 14.3949 10.3785L12.7734 12Z",
    fill: "#FF5E4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 8.13078 8.13108 5 12 5C15.8692 5 19 8.13105 19 12C19 15.8692 15.8689 19 12 19C8.13078 19 5 15.8689 5 12ZM6.09375 12C6.09375 15.2647 8.73559 17.9062 12 17.9062C15.2647 17.9062 17.9062 15.2644 17.9062 12C17.9062 8.73535 15.2644 6.09375 12 6.09375C8.73535 6.09375 6.09375 8.73557 6.09375 12Z",
    fill: "#FF5E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.01d89d5e2069c70316a8025d40a91bca.svg";
export { ForwardRef as ReactComponent };